import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '@material/material.module';
import { AddProspectModule } from '@shared/add-prospect/add-prospect.module';
import { DropdownMenuWithIconsComponent } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.component';
import { DropdownMenuWithIconsService } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.service';
import { DropdownMenuWithRejectComponent } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-reject.component';
import { FeatureFlagsDirectiveModule } from 'mojo-feature-flags';

@NgModule({
  declarations: [DropdownMenuWithIconsComponent, DropdownMenuWithRejectComponent],
  exports: [DropdownMenuWithIconsComponent, DropdownMenuWithRejectComponent],
  imports: [
    MaterialModule,
    MatIconModule,
    CommonModule,
    FeatureFlagsDirectiveModule,
    MatDialogModule,
    AddProspectModule,
  ],
  providers: [DropdownMenuWithIconsService],
})
export class DropdownMenuWithIconsModule {}
